import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import { useSavePromotionMutation } from "../../services/hr.service";
import { Select } from "antd";
import { useLazySearchEmployeesQuery } from "../../services/employee.service";
import { useGetDesignationsQuery } from "../../services/settings.service";
import { useForm, Controller } from "react-hook-form";
import { ClipLoader } from "react-spinners";
import { customStyles } from "../../utils";
import { PromotionSchema } from "../../utils/validationSchema";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import dayjs from "dayjs";
import alertify from "alertifyjs";

const { Option } = Select;

const PromotionModal = ({item}) => {
  const {user} = useSelector((state) => state.user);

  const branch_id = (!['HR Admin', 'Admin', 'HR Assistant'].includes(user?.role)) ? user?.branch?.id : ''
  const [employees, setEmployees] = useState([]);
  const [searchEmployees, {data: searchData, error: searchError}] = useLazySearchEmployeesQuery();
  const [saveResignation, {data, isLoading, isSuccess, error}] = useSavePromotionMutation();
  const {data: designationData} = useGetDesignationsQuery();

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(PromotionSchema),
  });

  useEffect(() => {
    if (searchData) {
      setEmployees(searchData?.data)
    }
  }, [searchData, searchError])

  useEffect(() => {
    if (isSuccess && data?.success){
      alertify.success(data?.message);
      document.getElementById('close-modal').click();

      setValue('employee_id', "");
      setValue('designation_id', "");
      setValue('promotion_date', "");
      setValue('id', "");
    }

    if (data && !data.success)
      alertify.error(data.errors);

    if (error) 
      alertify.error(error?.message);

  }, [data, error, isSuccess]);

  useEffect(() => {
    if (item) {
      setEmployees([...employees, {
        id: item.employee.id,
        name: item.employee.first_name + ' ' + item.employee.last_name,
        designation: item.employee.designation,
        department: item.department
      }]);
      setValue('employee_id', item.employee.id);
      setValue('designation_id', item.new_designation?.id);
      setValue('promotion_date', dayjs(item.promotion_date).toDate());
      setValue('id', item.id);
    }
  }, [item]);

  const findEmployees = (value) => {
    if (value) {
      searchEmployees({q:value, branch_id});
    } else {
      setEmployees([]);
    }
  }

  const save = payload => {
    payload.promotion_date = dayjs(payload.promotion_date).format('YYYY-MM-DD');
    saveResignation(payload);
  }

  return (
    <>
      {/* Add Promotion Modal */}
      <div id="promotion_modal" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{item ? 'Edit' : 'Add'} Promotion</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="close-modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(save)}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Promotion For <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="employee_id"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        showSearch
                        size="large"
                        value={value}
                        style={{width: '100%'}}
                        defaultActiveFirstOption={false}
                        filterOption={false}
                        onSearch={findEmployees}
                        onChange={(value) => {
                          onChange(value);
                          const employee = employees.find(employee => employee.id === value);
                          if (employee) {
                              setValue('prev_designation', employee.designation.name);
                          }
                        }}
                        notFoundContent={null}
                      >
                        {employees.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>)}
                      </Select>
                    )}
                  />
                  <span className="text-danger">
                      {errors?.employee_id?.message}
                  </span>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Promotion From <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="prev_designation"
                    control={control}
                    render={({ field: { value } }) => (
                      <input
                        className="form-control"
                        type="text"
                        // defaultValue="Web Developer"
                        value={value}
                        readOnly
                      />
                    )}
                  />
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Promotion To <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="designation_id"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                          size="large"
                          value={value}
                          placeholder="Select "
                          styles={customStyles}
                          style={{width: '100%'}}
                          onChange={onChange}
                        >
                          {designationData?.data.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>)}
                        </Select>
                    )}
                  />
                  <span className="text-danger">
                        {errors?.designation_id?.message}
                    </span>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Promotion Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <Controller
                      name="promotion_date"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <DatePicker
                          selected={value || null}
                          onChange={onChange}
                          className="form-control floating datetimepicker"
                          type="date"
                          dateFormat="dd-MM-yyyy"
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors?.promotion_date?.message}
                    </span>
                  </div>
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    disabled={isLoading}
                  >
                    {!isLoading ? 'Submit' : <ClipLoader color="#ffffff" />}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Promotion Modal */}
    </>
  );
};

export default PromotionModal;
